import querystring from 'querystring'

export default function (obj) {
  const data = {}
  Object.keys(obj).sort().forEach(k => {
    let v = obj[k]
    if (typeof v === 'object') {
      v = JSON.stringify(v)
    }
    data[k] = v
  })
  return querystring.stringify(data)
}



// WEBPACK FOOTER //
// ./src/utils/to-request-body.js